import { getLocation } from '@/core/data/gateways/api';
import { resolveAll } from '@/core/utils/promises';
import { getUser } from '../identity/user.service.client';
import type { EventData } from './event.schema';

export async function getProperties(): Promise<EventData> {
	const [location, user] = await resolveAll(getLocation(), getUser());

	return {
		data: {},
		user: {
			email: user?.hashedEmail ?? null,
			ipAddress: location?.ip ?? '0.0.0.0',
			locale: {
				country: location?.country_code ?? '',
			},
			phone: user?.hashedPhone ?? null,
		},
	};
}
